<template>
    <el-row class="cs-contentContainer">
        <el-col :span="12" class="cs-contentContainer-loginLeft">
            <div>&nbsp;</div>
        </el-col>
        <el-col :span="12" class="cs-fullHeight cs-contentContainer-loginMiddle">
            <div class="cs-fullHeight-content cs-contentContainer-loginMiddle-loginWindow">
                <el-form :model="loginForm" :rules="rules" ref="loginForm">
                    <div>
                        <el-row>
                            <el-col :span="24" class="cs-contentContainer-loginMiddle-loginWindow-topLine">
                            </el-col>
                        </el-row>
                        <el-row class="cs-login-content">
                            <el-col :span="24" class="cs-login-content">
                                <div class="grid-content">
                                                <el-row class="el-form-control">
                                        <el-col :span="0"></el-col>
                                        <el-col :span="24" class="cs-login-content-title">
                                            员工登陆
                                        </el-col>

                                    </el-row>
                                                   <el-row class="el-form-control">
                                        <el-col :span="0"></el-col>
                                        <el-col :span="24">
                                            <div class="user-avatar--circle">
                                                <div class="block">
                                                    <el-avatar :size="94" :src="require('@/assets/profile.png')"></el-avatar>
                                                </div>
                                            </div>
                                        </el-col>
                                    </el-row>
                                    <el-row class="el-form-control">
                                        <el-col :span="0"></el-col>
                                        <el-col :span="24">
                                            <el-form-item prop="name">
                                                <el-input @change='checkAllInputs' placeholder="请输入用户名"  v-model.trim="loginForm.name" @focus='onFocusName'></el-input>
                                                  <div class="el-form-item__error" v-if="showError">
                                                      {{ errorMessage }}
                                            </div>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row class="el-form-control">
                                        <el-col :span="0">&nbsp;</el-col>
                                        <el-col :span="24">
                                            <el-form-item prop="password">
                                                <el-input @keyup.enter.native="login" @change='checkAllInputs' placeholder="请输入登录密码" type="password" v-model="loginForm.password" @focus='onFocusPwd'>
                                                </el-input>
                                                 <div class="el-form-item__error"  v-if="showErrorWrongPwd">
                                                      *密码错误
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row class="el-form-control">
                                        <el-col :span="0">&nbsp;</el-col>
                                        <el-col :span="24">
                                            <el-button v-bind:type="btnClass" @click="login" class="el-btn-login">登 录</el-button>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
        </el-col>
    </el-row>
</template>


<style lang="scss" scoped>
.errorMessageContainer {
    min-height: 56px;
}
.cs-contentContainer{
    height: 100%;
    overflow: hidden;
}
/deep/ .el-form-item__error {
    margin-left: 200px;
    padding-top: 0px;
    margin-top: -28px;
}
.el-form-control {
    margin-bottom: 0px;
}
.user-avatar--circle {
    display: table;
    margin: 20px auto;
}
.cs-login-content-title {
    color: #000000;
    font-size: 20px;
    text-align: center;
}
.cs-login-bottom {
    height: 60px;
    footer {
        line-height: 60px;
    }
}
/deep/ .el-input__inner {
    border-radius: 22px;
    width: 315px;
    height: 44px !important;
    font-size: 14px;
    color: #000000;
    background-color: #f7f7f7;
    margin-top: 14px;
    text-align: left !important;
}
.el-form-item {
    margin-bottom: 0px;
}

.el-btn-login {
    border-radius: 30px;
    width: 315px;
    height: 55px !important;
    font-size: 14px;
    color: white;
    background-color: #006bb4;
    margin-top: 28px;
    border: 0;
}
.el-btn-login:hover {
    background-color: #2957a2;
}

.grid-content {
    display: table;
    margin: 0 auto;
}

.cs-login-content {
    padding-top: 15px;
}


</style>

<script>
import { userLogin, validateToken } from "../../service/user.service";
import {
    getStore,
    setStore,
    saveUserInStore,
    redirect
} from "../../config/mUtils";
import global_ from "../../core/global";
export default {
    data() {
        return {
            size: "large",
            global: global_,
            showError: false,
            showErrorWrongPwd: false,
            errorMessage: "",
            btnClass: "info",
            loginForm: {
                name: "", //用户名
                password: "",
                loginType: global_.loginType.speedup.name
            },
            rules: {
                name: [{
                        required: true,
                        message: "请输入用户名",
                        trigger: "blur"
                    },
                    {
                        min: 0,
                        max: 20,
                        message: "最大长度在为20个字符",
                        trigger: "blur"
                    }
                ],
                password: [{
                    required: true,
                    message: "请输入密码",
                    trigger: "blur"
                }]
            }
        };
    },
    created() {
        this.validateUserLogin();
    },
    // computed: {
    //     //判断手机号码
    //     rightPhoneNumber: function (){
    //         return /^1\d{10}$/gi.test(this.phoneNumber)
    //     }
    // },
    methods: {
        validateUserLogin() {
            let token = getStore("auth_token");
            let role = getStore("user_role");
            if (token && role) {
                validateToken().then(result => {
                    if (!!result && result.success) {
                        this.$emit("logged-event", true);
                        this.checkLoginUser();
                    }
                });
            }
        },
        //发送登录信息
        async login() {
            if (!!this.$refs["loginForm"]) {
                let isValid = true;
                this.$refs["loginForm"].validate(valid => {
                    if (valid) {} else {
                        isValid = false;
                    }
                });
                if (!isValid) {
                    return false;
                }
                let result = await userLogin(
                    this.loginForm.name,
                    this.loginForm.password,
                    this.loginForm.loginType
                );
                if (result) {
                    if (!result.success) {
                         this.errorMessage = result.message;
                        if(this.errorMessage==='密码错误'){

                            this.showErrorWrongPwd = true;
                        }else{

                            this.showError = true;
                        }
                    } else {
                        saveUserInStore(result.data);
                        this.$emit("logged-event", true);
                        this.checkLoginUser();
                    }
                }
            }
        },
        checkLoginUser(){
            redirect(this.$router, this.USERMANAGER);
            // if (this.USERMANAGER.isSales || this.USERMANAGER.isAssistant || this.USERMANAGER.isReceptionist || this.USERMANAGER.isEducationalAssistant) {
            //     this.$router.push("/admin/studentList");
            // } else if (this.USERMANAGER.isFinancial) {
            //     this.$router.push("/finance/accountList");
            // } else if (this.USERMANAGER.isTeacher) {
            //     this.$router.push("/teacher/activateCourse");
            // } else if (this.USERMANAGER.isPlatformEditor) {
            //     this.$router.push("/admin/schoolHotList");
            // } else if (this.USERMANAGER.isPersonnelManagement) {
            //     this.$router.push("/admin/accountManage");
            // } else if (this.USERMANAGER.isStudyAbroad) {
            //     this.$router.push("/studyAbroad/studentInfoList");
            // } else {
            //     this.$router.push("/admin/studentList");
            // }
        },
        goRegister() {
            this.$router.push("/register");
        },
        checkAllInputs() {
            if (!!this.loginForm.name && !!this.loginForm.password) {
                this.btnClass = "primary";
            } else {
                this.btnClass = "info";
            }
        },
         onFocusName(event){
            if(this.showError){
              this.loginForm.name='';
              this.showError=false;
            }
        },
        onFocusPwd(event){
            if(this.showErrorWrongPwd){
              this.loginForm.password='';
              this.showErrorWrongPwd=false;
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/page/admin/login.vue